import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import { type APIResponse, type MatterEmail } from "@/lib/types";

export interface SendMatterEmailPayload {
  matterId: string;
  toEmails: string[];
  ccEmails?: string[];
  bccEmails?: string[];
  templateName: "CustomMessageEmailTemplate";
  templateData: {
    subject: string;
    custom_message: string;
    firm_name: string;
  };
  fileIds?: string[];
}

export const sendMatterEmailV2 = (data: SendMatterEmailPayload) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterEmail>
    >(`${baseFastApiMatterRoute}/emails/send`, data)
    .then((res) => res.data);
};

export const deleteMatterEmailV2 = ({
  matterId,
  emailId,
}: {
  matterId: string;
  emailId: string;
}) => {
  return authenticatedFastApiAxiosInstance
    .delete<APIResponse<MatterEmail>>(
      `${baseFastApiMatterRoute}/emails/${emailId}`,
      {
        params: { matter_id: matterId },
      },
    )
    .then((res) => res.data);
};

export interface MatterEmailDownloadRequest {
  emailId: string;
  attachmentId?: string;
}

export const generateMatterEmailDownloadUrlV2 = ({
  emailId,
  attachmentId,
}: MatterEmailDownloadRequest) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<{ key: string; presignedUrl: string }>
    >(`${baseFastApiMatterRoute}/emails/${emailId}/download`, attachmentId ? { attachmentId } : {})
    .then((res) => res.data);
};
